(() => {
  if (window.__mkoProductUiReady) return;
  window.__mkoProductUiReady = true;

  const ROOT_SELECTOR = '.main-product[data-ui-component="Main Product Section"]';
  const normalise = (value = '') =>
    value.replace(/\s+/g, ' ').trim().toLowerCase();

  const enhanceSaleBadge = (root) => {
    root.querySelectorAll('.product__prices .sale-badge').forEach((badge) => {
      const match = badge.textContent.match(/(\d+(?:[.,]\d+)?)\s*%/);
      if (!match) return;

      const percentage = Math.round(
        Number(match[1].replace(',', '.'))
      );
      if (!Number.isFinite(percentage)) return;

      badge.classList.add('mko-sale-badge');
      const text = badge.querySelector('.tt-up') || badge;
      const desired = `RISPARMI ${percentage}%`;

      if (text.textContent.trim() !== desired) text.textContent = desired;
      badge.setAttribute(
        'aria-label',
        `Risparmi il ${percentage} percento`
      );
    });
  };

  const ensureCodHeading = (block) => {
    if (block.querySelector('.mko-product-cod-heading')) return;

    block
      .querySelectorAll(':scope > .mko-product-cod-label')
      .forEach((element) => element.remove());

    const heading = document.createElement('div');
    heading.className = 'mko-product-cod-heading';

    const label = document.createElement('span');
    label.className = 'mko-product-cod-label';
    label.textContent = 'Preferisci pagare alla consegna?';

    const note = document.createElement('span');
    note.className = 'mko-product-cod-note';
    note.textContent = 'Completa l’ordine senza pagamento online.';

    heading.append(label, note);
    block.prepend(heading);
  };

  const insertReviewSummary = (root) => {
    if (root.querySelector('.mko-review-summary')) return;

    const template = document.getElementById(
      'mko-review-summary-template'
    );
    const titleBlock = root.querySelector('.product__title');

    if (!template?.content?.firstElementChild || !titleBlock) return;

    const summary = template.content.firstElementChild.cloneNode(true);
    titleBlock.insertAdjacentElement('afterend', summary);
  };

  const classifyAppBlocks = (root) => {
    const infoBlocks = [
      ...root.querySelectorAll(
        '.main-product-info-container > .product__info'
      )
    ];

    const scalapayBlocks = [];
    const codBlocks = [];

    infoBlocks.forEach((block) => {
      const signal = normalise(
        `${block.textContent || ''} ${block.innerHTML || ''}`
      );

      const isScalapay =
        block.classList.contains('ord-4') ||
        signal.includes('scalapay');

      const isCod =
        block.classList.contains('ord-8') ||
        signal.includes('releasit') ||
        signal.includes('cod-form') ||
        signal.includes('cash on delivery') ||
        signal.includes('paga alla consegna') ||
        signal.includes('pagamento alla consegna') ||
        signal.includes('contrassegno');

      if (isScalapay) scalapayBlocks.push(block);
      if (isCod) codBlocks.push(block);
    });

    scalapayBlocks.forEach((block, index) => {
      block.classList.add('mko-payment-message');
      if (index > 0) {
        block.hidden = true;
        block.classList.add('mko-duplicate-payment-message');
        block.setAttribute('aria-hidden', 'true');
      }
    });

    codBlocks.forEach((block) => {
      block.classList.add('mko-product-cod-block');
      ensureCodHeading(block);
    });
  };

  const initProduct = (root) => {
    if (!root || root.dataset.mkoProductReady === 'true') return;
    root.dataset.mkoProductReady = 'true';

    enhanceSaleBadge(root);
    insertReviewSummary(root);
    classifyAppBlocks(root);

    const priceArea = root.querySelector('[id^="productPrice-"]');
    if (priceArea) {
      const priceObserver = new MutationObserver(() =>
        enhanceSaleBadge(root)
      );
      priceObserver.observe(priceArea, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    const infoArea = root.querySelector(
      '.main-product-info-container'
    );
    if (infoArea) {
      const appObserver = new MutationObserver(() =>
        classifyAppBlocks(root)
      );
      appObserver.observe(infoArea, {
        childList: true,
        subtree: true,
        characterData: true
      });
      window.setTimeout(() => appObserver.disconnect(), 15000);
    }
  };

  const init = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initProduct(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) =>
    init(event.target)
  );
})();